export enum TermSet {
  RenterScreening = 'renterScreening',
  LandlordScreening = 'landlordScreening',
}

export enum ExitReason {
  NotAuthenticated = 'NotAuthenticated',
  CurrentlyIdentified = 'CurrentlyIdentified',
  IdVerified = 'IdVerified',
  UserNotFound = 'UserNotFound',
  UserLockedOut = 'UserLockedOut',
  UserNotFoundLockedOut = 'UserNotFoundLockedOut',
  IncorrectAnswers = 'IncorrectAnswers',
  ForbiddenIp = 'ForbiddenIp',
  ThinCreditFile = 'ThinCreditFile',
  FrozenAccount = 'FrozenAccount',
  FrozenAccountWarning = 'FrozenAccountWarning',
  GenericError = 'GenericError',
  ModalClose = 'ModalClose',
  CurrentlyIdentifiedAcceptedNewTerms = 'CurrentlyIdentifiedAcceptedNewTerms',
  AttemptedReAuthWithoutSsn = 'AttemptedReAuthWithoutSsn',
}

export enum LogLevel {
  Debug = 'debug',
  Info = 'info',
  Warn = 'warn',
  Error = 'error',
}

export interface LogData {
  message: string;
  error?: unknown;
}
